// MF entry exposed as ./AppMount; loads runtime settings + registers remotes before mounting the app.
import { loadAppSettings, setAppSettings } from './appSettings';
import { registerRuntimeRemotes } from './designSystemRemote';

// Settings the app can't boot without; validated up front to fail fast with a clear message.
const REQUIRED_SETTINGS = [
  'SHIPBOB_DESIGN_SYSTEM',
  'SHIPBOB_MFE_RUNTIME',
  'AUTHENTICATION_AUTHORITY',
  'CLIENT_ID',
  'CLIENT_SCOPE',
  'MFE_ROOT_ROUTE',
];

/** Load settings, validate required keys (throws listing any missing), then register the runtime remotes. */
export async function prepareRuntime(action) {
  const appSettings = await loadAppSettings();

  const missing = REQUIRED_SETTINGS.filter(
    (key) => typeof appSettings[key] !== 'string' || !appSettings[key].trim(),
  );
  if (missing.length) {
    // Drop the incomplete cache so a later mount refetches (e.g. after config propagation) instead of
    // reusing a fetched-but-invalid appsettings.json until a hard reload.
    setAppSettings(null);
    throw new Error(`[inbound-management-ui] cannot ${action}: missing required app settings: ${missing.join(', ')}`);
  }

  const registered = registerRuntimeRemotes(appSettings);
  if (!registered) {
    setAppSettings(null);
    throw new Error(
      `[inbound-management-ui] cannot ${action}: failed to register one or more required runtime remotes`,
    );
  }
}

/** Mount into a host-provided element; returns the bootloader's unmount fn. */
export const mount = async (args = {}) => {
  await prepareRuntime('mount');
  const { mount: appMount } = await import('./bootloader');
  return appMount(args);
};
